import { IPaginatedRequest, IPaginatedResult } from './Util';

export enum TreatmentConsultationTypeEnum {
  teleorientation = 'Teleorientação',
  teleconsultation = 'Teleconsulta',
}

export enum TreatmentConsultationTypesEnum {
  teleorientation = 'teleorientation',
  teleconsultation = 'teleconsultation',
}

export interface ITreatmentConsultation {
  id: string;
  _id: string;
  treatmentId: string;
  vet: {
    _id: string;
    name: string;
  };
  pet: string;
  anamnesis: string;
  consultType: keyof typeof TreatmentConsultationTypeEnum;
  orientation: string;
  diagnosis: string;
  treatment: string;
  tutor?: string;
  createdAt: string;
  updatedAt: string;
  prescription?: ITreatmentPrescription;
}

export type ITreatmentPrescription = ITreatmentConsultationPrescriptionItem[];

export interface ITreatmentConsultationFilter {
  startDate?: string | Date | null;
  endDate?: string | Date | null;
}

export interface IFindTreatmentConsultationParams
  extends IPaginatedRequest,
    ITreatmentConsultationFilter {
  petId: string;
}

export interface ICreateTreatmentConsultation {
  id?: string;
  _id?: string;
  treatmentId: string;
  anamnesis: string;
  consultType: keyof typeof TreatmentConsultationTypeEnum;
  orientation: string;
  diagnosis: string;
  treatment: string;
  prescription?: ITreatmentConsultationPrescriptionItem[];
}

export interface ITreatmentConsultationPrescriptionItem {
  type: 'exam' | 'medicament';
  name?: string;
  /* Exam fields */
  indication?: string;
  /* Medication fields */
  posology?: string;
  way?: string;
  quantity?: string;
}

export interface ITreatmentConsultationExam {
  name: string;
}

export type ITreatmentConsultationResult =
  IPaginatedResult<ITreatmentConsultation>;
